<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog v-model="dialog" max-width="350px">
    <v-card>
      <v-card-title>
        <span class="headline">Gönderici Kayıt Formu</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" lazy-validation>
            <v-layout wrap>
              <v-flex xs12 sm8 md8>
                <v-text-field
                  v-model="senderName"
                  :rules="[$rules.empty('Gönderici Adı')]"
                  label="Gönderici Adı*"
                  required>
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small>*zorunlu olan alanları işaret eder.</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="dialog = false">Kapat</v-btn>
        <v-btn color="blue darken-1" flat @click="saveSender">Kaydet</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data: () => ({
    dialog: false,
    senderName: '',
    // notEmpty: checker('Gönderici Adı'),
  }),
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    setDialog() {
      this.dialog = !this.dialog;
    },
    saveSender() {
      if (this.$refs.form.validate()) {
        this.send({
          route: 'add/senders',
          data: {
            name: this.senderName,
          },
        })
          .then(() => {
            this.setDialog();
            setTimeout(() => {
              this.$trigger('load:senders');
            }, 1500);
          });
      }
    },
  },
  events: {
    'set:sender-create': 'setDialog',
  },
};
</script>
